import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Calculatrice de ventes nettes - Calculez les bénéfices nets avec précision";
const DESCRIPTION =
  "Calculez les ventes nettes a partir des ventes brutes, des retours et des remises accordees. Un outil utile pour suivre le chiffre d affaires reel et analyser la performance commerciale.";
const KEYWORDS =
  "calculatrice ventes nettes, calcul chiffre d affaires net, retours de ventes, remises commerciales, ventes brutes nettes";
const OG_URL = "https://do-calculate.com/calculator/fr/net-sales-calculator/";
const NetSalesCalculator = () => {
  const [totalSales, setTotalSales] = useState("");
  const [salesReturns, setSalesReturns] = useState("");
  const [allowedDiscounts, setAllowedDiscounts] = useState("");
  const [netSales, setNetSales] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const totalSalesValue = parseFloat(totalSales);
      const salesReturnsValue = parseFloat(salesReturns);
      const allowedDiscountsValue = parseFloat(allowedDiscounts);
      if (
        isNaN(totalSalesValue) ||
        isNaN(salesReturnsValue) ||
        isNaN(allowedDiscountsValue)
      ) {
        throw new Error("Veuillez saisir toutes les valeurs correctement.");
      }
      if (
        totalSalesValue < 0 ||
        salesReturnsValue < 0 ||
        allowedDiscountsValue < 0
      ) {
        throw new Error("Les valeurs saisies ne peuvent pas être négatives.");
      }
      const calculatedNetSales =
        totalSalesValue - salesReturnsValue - allowedDiscountsValue;
      setNetSales(calculatedNetSales.toFixed(8));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculatrice de ventes nettes</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de ventes nettes permet de connaitre le chiffre d affaires reel apres deduction des retours clients et des remises commerciales. C est un indicateur utile pour suivre la qualite des ventes, comparer des periodes et mieux comprendre ce qui reste vraiment apres les ajustements accordes a vos clients.
                </p>
                <p>
                  Cet outil s adresse aux commercants, e-commercants, responsables financiers et petites entreprises qui veulent verifier rapidement un niveau de ventes nettes sans passer par un tableur. Il aide aussi a repérer si des promotions trop agressives ou un taux de retour eleve reduisent la performance commerciale.
                </p>
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice de ventes nettes</h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Ventes totales
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Saisir les ventes totales"
                        value={totalSales}
                        onChange={(e) => setTotalSales(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Retours de ventes
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Saisir les retours de ventes"
                        value={salesReturns}
                        onChange={(e) => setSalesReturns(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Remise autorisée
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Saisir la remise autorisée"
                        value={allowedDiscounts}
                        onChange={(e) => setAllowedDiscounts(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                    <div>
                      <br />
                    </div>
                    { error && (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    )}
                    {netSales && (
                      <p className="p-3 mb-2 bg-success text-white">
                        Ventes nettes : {netSales}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi calculer les ventes nettes</h3></div>
              <div className="info-section-body"><p>Les ventes nettes donnent une image plus juste de l activite que les ventes brutes, car elles retirent les retours et les remises accordees aux clients.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil de saisie</h3></div>
              <div className="info-section-body"><p>Utilisez des montants releves sur la meme periode comptable afin que le resultat corresponde a une lecture fiable de votre chiffre d affaires net.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Lecture du resultat</h3></div>
              <div className="info-section-body"><p>Une baisse importante des ventes nettes par rapport aux ventes brutes peut signaler trop de remises, trop de retours ou un probleme de qualite produit.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NetSalesCalculator;
